import React from "react";

import Common from "./Common";
const ActivityDetail = (props) => {
  return (
    <>
      <Common {...props} />
    </>
  );
};

export default ActivityDetail;
